var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.625 13.8182C1.625 14.3404 1.83242 14.8411 2.20164 15.2104C2.57085 15.5796 3.07161 15.787 3.59375 15.787H15.4062C15.9284 15.787 16.4291 15.5796 16.7983 15.2104C17.1676 14.8411 17.375 14.3404 17.375 13.8182V8.40417H1.625V13.8182ZM3.94532 11.1464C3.94532 10.8666 4.05643 10.5984 4.25423 10.4006C4.45202 10.2028 4.72028 10.0917 5 10.0917H6.6875C6.96722 10.0917 7.23549 10.2028 7.43328 10.4006C7.63107 10.5984 7.74219 10.8666 7.74219 11.1464V11.8495C7.74219 12.1292 7.63107 12.3975 7.43328 12.5953C7.23549 12.7931 6.96722 12.9042 6.6875 12.9042H5C4.72028 12.9042 4.45202 12.7931 4.25423 12.5953C4.05643 12.3975 3.94532 12.1292 3.94532 11.8495V11.1464Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4062 3.4115H3.59375C3.07161 3.4115 2.57085 3.61892 2.20164 3.98813C1.83242 4.35734 1.625 4.8581 1.625 5.38025V6.29431H17.375V5.38025C17.375 4.8581 17.1676 4.35734 16.7983 3.98813C16.4291 3.61892 15.9284 3.4115 15.4062 3.4115Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletImg);
export default __webpack_public_path__ + "static/media/walletImg.9c44ca2b4df8a79b57d77cb2a1a2a6f1.svg";
export { ForwardRef as ReactComponent };